<script>
  // import input formatting functions
  import {
    formatCurrency,
    formatMonths,
    formatPercentage,
    setCursorPosition,
  } from '../util';
  // calculate refinance savings function
  import calculateRefinanceSavings from './calculateRefinanceSavings';
  // import calculator base components
  import CalculatorDisclaimer from '../CalculatorDisclaimer.svelte';
  import CalculatorFieldError from '../CalculatorFieldError.svelte';
  import CalculatorHeader from '../CalculatorHeader.svelte';
  import CalculatorSubmitInput from '../CalculatorSubmitInput.svelte';

  // company prop for passing to Disclaimer
  export let company;

  // fields
  let birthYear = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let zipCode = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let state = {
    value: '',
    error: false,
    errorMessage: 'Please select a value',
  };
  let propertyValue = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let loanBalance = {
    value: '',
    error: false,
    errorMessage: 'Please enter a value',
  };
  let propertyType = {
    value: '',
    error: false,
    errorMessage: 'Please select a Property Type',
  };

  // result values
  let oldLoanValues = {
    monthlyPayment: '',
    remainingLoanBalance: '',
    remainingTotalCost: '',
  };
  let newLoanValues = {
    monthlyPayment: '',
    monthlySavings: '',
    totalCost: '',
  };
  let totalSavings = '';

  // has the result been calculated?
  let calculated = false;
  let result = null;
  let resultError = null;

  let loading = false;




  function setCalculatedAndCalculate() {
    loading = true;
    result = null;
    resultError = null;

    // make sure all fields are valid before calculating return early if not
    if (!validateFields()) {
      loading = false;
      return;
    }

    let dateForYearBorn = new Date();
    dateForYearBorn.setYear(birthYear.value);
    let newDate = dateForYearBorn.toISOString();

      let dataToSend = {
      DobYoungestBefore: birthYear.value,
      ZipCode: zipCode.value,
      State: state.value,
      PropertyValue: removeSpecialCharacters(propertyValue.value),
      Liens: removeSpecialCharacters(loanBalance.value),
      propertyType: 'primary',
      DobYoungest: newDate,
      ProductId: 620,
    };

    console.log(dataToSend);

    const response =  sendData(dataToSend);
    
  }
  // Updated formatWithCommas function to include dollar sign
  const formatWithCommasAndDollarSign = (value) => {
    // Remove non-numeric characters except the decimal point and dollar sign
    let formattedValue = value.replace(/[^\d.]/g, '');
    // Add commas for thousands, millions, etc., and prefix with dollar sign
    return "$" + formattedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

   // Reactive statements for formatting as user types
  // Only add the dollar sign if there's input
  $: propertyValue.value = propertyValue.value && propertyValue.value.length > 0 
                            ? formatWithCommasAndDollarSign(propertyValue.value) 
                            : propertyValue.value;
  $: loanBalance.value = loanBalance.value && loanBalance.value.length > 0 
                            ? formatWithCommasAndDollarSign(loanBalance.value) 
                            : loanBalance.value;

  // Enhanced removeCommas function to also remove dollar signs
  const removeSpecialCharacters = (value) => {
    return value.replace(/[\$,]/g, '');
  };


  const sendData =  (dataToSend) => {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://onetrusthomeloans.com/",
      },

      body: JSON.stringify(dataToSend),
    };

     fetch(
      "/api/post-to-quantum-curl.php",
      options
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.ValidationResult) {
          console.log("error");
          resultError = response.ValidationResult.Message;
          console.log("result", response.ValidationResult.Message);
          return;
        }
        result = Math.floor(response.Result.PrincipalLimit) - dataToSend.Liens;

        if(result < 0){
          result = 0;
        }
       
        console.log(response);
      })
      .catch((err) => console.error(err));
      loading = false;

  };

   const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

    const removeCommas = (value) => {
    return value.replace(/,/g, '');
  };


const validateFields = () => {
  let isValid = true;

  // Validate birthYear
  if (!birthYear.value || birthYear.value.length !== 4 || isNaN(birthYear.value)) {
    birthYear.error = true;
    birthYear.errorMessage = 'Please enter a valid 4-digit year';
    isValid = false;
  } else {
    birthYear.error = false;
  }

  // Validate zipCode
  if (!zipCode.value || zipCode.value.length !== 5 || isNaN(zipCode.value)) {
    zipCode.error = true;
    zipCode.errorMessage = 'Please enter a valid 5-digit zip code';
    isValid = false;
  } else {
    zipCode.error = false;
  }

  // Validate state
  if (!state.value || state.value.length !== 2) {
    state.error = true;
    state.errorMessage = 'Please enter a valid 2-letter state abbreviation';
    isValid = false;
  } else {
    state.error = false;
  }

  // Validate propertyValue after removing special characters
  const numericPropertyValue = removeSpecialCharacters(propertyValue.value);
  if (!numericPropertyValue || isNaN(numericPropertyValue)) {
    propertyValue.error = true;
    propertyValue.errorMessage = 'Please enter a valid property value';
    isValid = false;
  } else {
    propertyValue.error = false;
  }

  // Validate loanBalance after removing special characters
  const numericLoanBalance = removeSpecialCharacters(loanBalance.value);
  if (!numericLoanBalance || isNaN(numericLoanBalance)) {
    loanBalance.error = true;
    loanBalance.errorMessage = 'Please enter a valid loan balance';
    isValid = false;
  } else {
    loanBalance.error = false;
  }

  // // Validate propertyType
  // if (!propertyType.value) {
  //   propertyType.error = true;
  //   propertyType.errorMessage = 'Please select a Property Type';
  //   isValid = false;
  // } else {
  //   propertyType.error = false;
  // }

  return isValid;
};

</script>

<div>
  <style>
    .loader {
        border: 5px solid rgba(0, 0, 0, 0.1);  /* Light grey */
        border-radius: 50%;
        border-top: 5px solid #99C24D;  /* Green */
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

  </style>
  <CalculatorHeader
    title="Reverse Mortgage Calculator"
    subtitle="Estimate the home equity you may be able to access with a Reverse Mortgage" />
  <form on:submit|preventDefault={setCalculatedAndCalculate}>
    <div class="bg-gray-efftwo px-16 py-8">
      <div class="calculator-input-fields-wrapper">
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="birthYear" class="block">
            Birth year of youngest borrower?
          </label>
          <input
            type="text"
            id="birthYear"
            name="birthYear"
            placeholder="1965"
            bind:value={birthYear.value}
            class="mt-2" />
          <CalculatorFieldError field={birthYear} />
        </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="zipCode" class="block">
            What is your zip code?
          </label>
          <input
            type="text"
            id="zipCode"
            name="zipCode"
            placeholder="92108"
            bind:value={zipCode.value}
            class="mt-2" />
          <CalculatorFieldError field={zipCode} />
        </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="state" class="block">
            What is your state's abbreviation?
          </label>
          <input
            type="text"
            id="state"
            name="state"
            placeholder="CA"
            bind:value={state.value}
            class="mt-2" />
          <CalculatorFieldError field={state} />
        </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="propertyValue" class="block">
            What is your estimated property value?
          </label>
          <input
            type="text"
            id="propertyValue"
            name="propertyValue"
            placeholder="$500,000"
            bind:value={propertyValue.value}
            class="mt-2" />
          <CalculatorFieldError field={propertyValue} />
        </div>
        <div class="calculator-field lg:mr-16 -mb-12 lg:mb-0 ">
          <label for="loanBalance" class="block">
            Estimated Loan Balance?
          </label>
          <input
            type="text"
            id="loanBalance"
            name="loanBalance"
            placeholder="$250,000"
            bind:value={loanBalance.value}
            class="mt-2" />
          <CalculatorFieldError field={loanBalance} />
        </div>
        <div class="calculator-field mb-8 lg:mb-0">
          <label for="originalLoanTerm" class="block">Property Type</label>
          <p class="text-sm text-gray-600 p-4">Primary Residence</p>

        </div>
      </div>
    </div>
    {#if loading}
      <div class="flex justify-center items-center my-24">
        <div class="loader"></div>
      </div>
    {:else}
      <CalculatorSubmitInput />
    {/if}
  </form>

  <div class="my-10">
    {#if result !== null && result === 0}
        <div class="px-6">
          <h4 class="mx-8 md:mx-24 text-3xl text-black mt-12">
            You have a unique financing scenario.
            <a href="/schedule-consultation" 
              style="color: #99C24D; font-size: 32px; text-decoration: underline;"
              class="hover:text-green-button">
                Schedule a Consultation
              </a>
              with a Reverse Mortgage Professional to explore your options!
          </h4>
           <CalculatorDisclaimer {company} />
        </div>
    {:else if result}
        <div class="px-6">
          <h4 class="mx-8 md:mx-24 text-3xl text-black mt-12">
            Congratulations you may be eligible to access up to 
            <span style="color: #99C24D; font-size: 32px;">
              ${numberWithCommas(result)} 
            </span>
            in home equity.
          </h4>
           <CalculatorDisclaimer {company} />
        </div>
    {/if}
    {#if resultError}
        <div>
          <h4 style="color: #CA4C43; font-size: 32px;" class="mx-8 md:mx-24 text-3xl text-red-800 mt-12">
            {resultError}
          </h4>
        </div>
    {/if}
</div>

</div>



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/reverseMortgageCalculator/ReverseMortgageCalculator.svelte